const PALE_GREEN_CODE = '#98FB98';
const PALE_YELLOW_CODE = '#f4f776';

export class ColorCodeModel{
    public static PALE_GREEN  = PALE_GREEN_CODE;
    public static PALE_YELLOW = PALE_YELLOW_CODE;
}